if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"webapp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2((676|81|960)4|0946|140)|442(0|38)|6(3880|6992|8750)|8((138|847|883)0|1128)|17548|30597|79010)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}